import { render, staticRenderFns } from "./WebClientLayout.vue?vue&type=template&id=56b7e4d1&scoped=true"
import script from "./WebClientLayout.vue?vue&type=script&lang=js"
export * from "./WebClientLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7e4d1",
  null
  
)

export default component.exports